import { render } from "./AGCAREListDetail.vue?vue&type=template&id=aae9007a&scoped=true"
import script from "./AGCAREListDetail.vue?vue&type=script&lang=js"
export * from "./AGCAREListDetail.vue?vue&type=script&lang=js"

import "./AGCAREListDetail.vue?vue&type=style&index=0&id=aae9007a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae9007a"]])

export default __exports__